import { useChannel as useAblyChannel } from "ably/react";
import {
  CacheMessageSchemaByType,
  type CacheMessageType,
  type ChannelMessageCallback,
} from "@remi/types/socket/message";

import type { CacheChannelProps } from "../utils/cache";
import { getCacheChannelName } from "../utils/cache";

type UseCacheChannelProps<T extends CacheMessageType> = CacheChannelProps & {
  entityType: T;
};

export const useCacheChannel = <T extends CacheMessageType>(
  channelProps: UseCacheChannelProps<T>,
  callback: ChannelMessageCallback<T>,
) => {
  const channelName = getCacheChannelName(channelProps.entityType, channelProps.entityId);

  return useAblyChannel(channelName, (message) => {
    const parsed = CacheMessageSchemaByType[channelProps.entityType].safeParse(message.data);
    if (!parsed.success) {
      return;
    }
    callback(parsed.data);
  });
};
